import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IPageExtendBehavior } from "../../../../documaker/domain/format/objects";

export interface IPageExtendBehaviorPropertyEditable {
  pageExtendBehavior(): IPropertyEditable<IPageExtendBehavior>;
}

export function instanceOfIPageExtendBehaviorPropertyEditable(instance: any): instance is IPageExtendBehaviorPropertyEditable {
  return instance
      && instance.pageExtendBehavior
      && instanceOfIPropertyEditable<IPageExtendBehavior>(instance.pageExtendBehavior());
}
